module.exports = __webpack_public_path__ + "img/ee.dbe399b1.svg";